
<div class="filtercontainer">
  <input type="text" placeholder="Search Expense" onchange="change($event)">
  <img src="/assets/images/search.svg"/>
</div>